(function () {
  // The header renders one search form for desktop and one for mobile, so
  // every instance gets its own state rather than sharing module scope.
  function initPredictiveSearch(form) {
    var input = form.querySelector('[data-search-input]');
    var results = form.querySelector('[data-search-results]');
    if (!input || !results) return;

    var predictiveSearchUrl = form.dataset.predictiveSearchUrl;
    var debounceTimer;
    var activeIndex = -1;
    var currentQuery = '';

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }

    // The suggest endpoint hands back the ORIGINAL image, unresized, so a
    // thumbnail this size was pulling down full product photos. The CDN sizes
    // on demand from a width parameter; 160 covers the 56px box at 2x.
    function thumbnailUrl(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
    }

    function renderResults(data, query) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (!products.length) {
        results.innerHTML =
          '<p class="header__search-empty">No hay resultados para &ldquo;' + escapeHtml(query) + '&rdquo;</p>';
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      var html = products
        .map(function (product) {
          return (
            '<a href="' +
            product.url +
            '" class="header__search-result" role="option">' +
            '<span class="header__search-result__media">' +
            (product.image
              ? '<img src="' + thumbnailUrl(product.image) + '" alt="" width="56" height="56" loading="lazy">'
              : '') +
            '</span>' +
            '<span>' +
            '<span class="header__search-result__title">' +
            escapeHtml(product.title) +
            '</span>' +
            '</span>' +
            '</a>'
          );
        })
        .join('');

      html +=
        '<a class="header__search-view-all" href="' +
        form.action +
        '?q=' +
        encodeURIComponent(query) +
        '">Ver todos los resultados para &ldquo;' +
        escapeHtml(query) +
        '&rdquo;</a>';

      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function fetchResults(query) {
      // `fields` has to be spelled out to reach variants.sku. The predictive
      // endpoint defaults to title/product_type/variants.title/vendor only, so
      // without this a SKU search returns nothing here even though the full
      // results page finds it — /search matches SKUs out of the box.
      var url =
        predictiveSearchUrl +
        '.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          if (!data || query !== currentQuery) return;
          renderResults(data, query);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      currentQuery = query;

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 250);
    });

    input.addEventListener('keydown', function (event) {
      var options = results.querySelectorAll('.header__search-result');
      if (!options.length || results.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        activeIndex = Math.min(activeIndex + 1, options.length - 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
      } else if (event.key === 'Enter' && activeIndex > -1) {
        event.preventDefault();
        options[activeIndex].click();
        return;
      } else if (event.key === 'Escape') {
        closeResults();
        return;
      } else {
        return;
      }

      options.forEach(function (option, index) {
        option.classList.toggle('is-active', index === activeIndex);
      });
      options[activeIndex].scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) closeResults();
    });
  }

  document.querySelectorAll('[data-predictive-search]').forEach(initPredictiveSearch);
})();
